import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { DashboardEntity } from './dashboard.entity';
import { UserEntity } from './user.entity';

@Index('idx_dashboard_user_unique', ['dashboardId', 'userId'], {
	unique: true,
})
@Index('idx_dashboard_user_dashboard', ['dashboardId'])
@Index('idx_dashboard_user_user', ['userId'])
@Entity('dashboard_user')
export class DashboardUserEntity extends BaseEntity {
	@Column('int', { name: '_fk_dashboard__id', unsigned: true })
	public dashboardId!: number;

	@Column('int', { name: '_fk_user__id', unsigned: true })
	public userId!: number;

	@ManyToOne(() => DashboardEntity, (dashboard) => dashboard.sharedUsers, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_dashboard__id', referencedColumnName: 'id' }])
	public dashboard!: DashboardEntity;

	@ManyToOne(() => UserEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public user!: UserEntity;
}
